module.exports = __webpack_public_path__ + "img/Dantam Hair 45.1f62ca68.jpg";